import { Component, OnInit } from '@angular/core';
import { AbstractWidgetComponent } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { TerminalContextConstants } from '@sdbn/tmc-common';
import { AppServerAPI } from '@sdbn/common';
import { VisitorPrintRegistrationCard } from '../visitor-registration.model';

@Component({
    selector: 'app-visitor-registration-qrcode',
    templateUrl: './visitor-registration-qrcode.component.html',
    styleUrls: ['./visitor-registration-qrcode.component.scss'],
    standalone: false
})
export class VisitorRegistrationQRCodeComponent extends AbstractWidgetComponent implements OnInit {

  lastname: string;
  firstname: string;
  numberPlate: string;
  company: string;
  reason: string;
  visitedPerson: string;
  needsAreaAccess: boolean;
  visitorType: number;
  inviterId: number;
  registrationCode: string;

  qrCodeContent: string;

  darkMode = false;
  foregroundColor: string = this.darkMode ? '#ffffff' : '#000000';
  backgroundColor: string = this.darkMode ? '#000000' : '#ffffff';
  qrScale = 4;

  constructor(
    private appServerAPI: AppServerAPI,
    public translationService: TranslationService
  ) {
    super();
  }

  ngOnInit(): void {
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
    this.lastname = this.dashboardContext.getContextValue(TerminalContextConstants.lastname);
    this.firstname = this.dashboardContext.getContextValue(TerminalContextConstants.firstname);
    this.company = this.dashboardContext.getContextValue(TerminalContextConstants.company);
    this.numberPlate = this.dashboardContext.getContextValue(TerminalContextConstants.numberPlate);
    this.reason = this.dashboardContext.getContextValue(TerminalContextConstants.reasonForVisit);
    this.visitedPerson = this.dashboardContext.getContextValue(TerminalContextConstants.visitedPerson);
    this.needsAreaAccess = this.dashboardContext.getContextValue('needsAreaAccess');
    this.visitorType = this.dashboardContext.getContextValue('visitorType');
    this.registrationCode = this.dashboardContext.getContextValue(TerminalContextConstants.registrationCode);
    this.inviterId = this.dashboardContext.getContextValue('inviterId');
    this.qrCodeContent = this.createQRCodeContent();
  }

  download() {
    const printRegistrationCard = new VisitorPrintRegistrationCard();
    printRegistrationCard.terminalIdentifier = null;
    printRegistrationCard.company = this.company;
    printRegistrationCard.firstname = this.firstname;
    printRegistrationCard.lastname = this.lastname;
    printRegistrationCard.needsAreaAccess = this.needsAreaAccess;
    printRegistrationCard.numberPlate = this.numberPlate;
    printRegistrationCard.reason = this.reason;
    printRegistrationCard.registrationQRCode = this.qrCodeContent;
    printRegistrationCard.visitedPerson = this.visitedPerson;
    printRegistrationCard.visitorType = this.visitorType;

    // Trigger opening a new tab. Must be as close as possible to a user action event.
    const newWindow = window.open('', 'registration');

    // keep focus in current window
    window.focus();

    const url = '/terminal/registration/visitor/download-registrationcard';
    this.appServerAPI.postWithArraybufferResponse<any>(url, printRegistrationCard).subscribe(result => {

      const file = new Blob([result], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);

      // we can open the file in a new tab
      if (newWindow !== null) {
        newWindow.location.href = fileURL;
      } else { // Fallback, if initial opener does not work. But popup blockers will block this.
        window.open(fileURL);
      }

    }, error => {
      console.error(error);
    });
  }

  private createQRCodeContent(): string {

    let content = 'tmc-visit://registration?'
              + 'registrationDate=' + Date.now() // UTC long value
              + '&lastname=' + (this.lastname != null ? this.lastname : '')
              + '&firstname=' + (this.firstname != null ? this.firstname : '')
              + '&company=' + (this.company != null ? this.company : '')
              + '&numberPlate=' + (this.numberPlate != null ? this.numberPlate : '')
              + '&reason=' + (this.reason != null ? this.reason : '')
              + '&visitedPerson=' + (this.visitedPerson != null ? this.visitedPerson : '')
              + '&needsAreaAccess=' + (this.needsAreaAccess === true)
              + '&visitorType=' + (this.visitorType != null ? '' + this.visitorType : '')
              + '&instructionsFinished=true';
    if (this.inviterId != null) {
      content += '&inviterId=' + this.inviterId;
    }
    if (this.registrationCode != null && this.registrationCode.trim().length > 0) {
      content += '&registrationCode=' + this.registrationCode;
    }
    return content + '&hash=' + this.createChecksum(content);
  }

  private createChecksum(url: string): string {
    var checksum = 0x12345678;
    for (var i = 0; i < url.length; i++) {
        checksum += (url.charCodeAt(i) * (i + 1));
    }
    return (checksum & 0xffffffff).toString(16);
  }

}
